import { useThemeUI } from 'theme-ui';

const useBorderStyles = (classnames) => {
  const { theme } = useThemeUI();
  const borderStyles = theme.borders;

  if (!classnames) return null;

  const classNamesArray = classnames.split(' ');

  for (const className of classNamesArray) {
    if (borderStyles[className]) {
      return borderStyles[className];
    }
  }

  return null;
};

export default useBorderStyles;